
import React from 'react';

const IVHero = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/7ee0750347f7dddeeed491ba8f885d3f.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold mb-6 lg:mb-8 leading-tight">
            Premium <strong>IV Vitamin Therapy</strong> for Optimal Wellness
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl mb-8 lg:mb-12 leading-relaxed opacity-90">
            Boost your energy, enhance immunity, and optimize your health with our comprehensive IV vitamin and nutrient infusion therapies.
          </p>
          
          <div className="grid sm:grid-cols-3 gap-6 lg:gap-8 mb-8 lg:mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 lg:p-6">
              <div className="text-2xl lg:text-3xl font-bold mb-2">15+</div>
              <div className="text-sm lg:text-base opacity-90">IV Formulations</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 lg:p-6">
              <div className="text-2xl lg:text-3xl font-bold mb-2">100%</div>
              <div className="text-sm lg:text-base opacity-90">Bioavailability</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 lg:p-6">
              <div className="text-2xl lg:text-3xl font-bold mb-2">30-60 Min</div>
              <div className="text-sm lg:text-base opacity-90">Treatment Time</div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <button className="bg-gradient-to-r from-orange-600 to-orange-700 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Book IV Therapy
            </button>
            <button className="bg-white/20 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-xl text-lg font-semibold hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer">
              View Treatments
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IVHero;
